import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { State, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    Customer,
    CustomerStatus,
    CustomerStatusChecklist,
    CustomerStatusChecklistMap,
    Employee
} from '../../models/models';

@Component({
    selector: 'customer-status-checklist-form',
    templateUrl: './customer-status-checklist-form.component.html',
    standalone: false
})
export class CustomerStatusChecklistForm implements OnInit, OnChanges {
    @Input() customerID: number = 0;
    @Input() customerStatusID: number = 0;
    @Input() isShowLeadStatusType: boolean = false;
    @Output() onRefresh = new EventEmitter<any>();

    public selectedCustomerID: number = 0;
    public customer: Customer = { name: '' } as Customer;
    public customerStatusAllList: CustomerStatus[] = [];
    public customerStatusList: CustomerStatus[] = [];
    public customerStatusChecklists: CustomerStatusChecklist[] = [];
    public checklistMaps: CustomerStatusChecklistMap[] = [];
    public allChecklistMaps: CustomerStatusChecklistMap[] = [];
    public employees: Employee[] = [];
    public isCRMAdmin: boolean = false;

    public currentStatus: CustomerStatus = {} as CustomerStatus;
    public currentStep: number = 0;

    constructor(private crmService: CRMService, private employeeService: EmployeeService, private utilService: UtilService) { }

    ngOnInit() {
        this.currentStep = 0;
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getEmployees();
        this.getCustomerStatuses();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.customerStatusAllList.length > 0) {
            this.getCustomerStatuses();
            //var customerStatus = this.customerStatusAllList.find(s => s.customerStatusId == this.customerStatusID);
            //this.currentStatus = customerStatus!;
            //this.currentStep = customerStatus!.stage - 1;
            this.setCurrentStatus();
            this.setDisplayStatusList();
            this.setCurrentStep();
        }
        if (changes.customerID == null || changes.customerID.currentValue.toString() == '' || parseInt(changes.customerID.currentValue.toString()) < 1) return;
        this.selectedCustomerID = parseInt(changes.customerID.currentValue.toString());
        this.getCustomer();
    }

    private refreshData() {
        if (this.customerStatusAllList.length > 0) {
            this.getCustomerStatuses();
            //var customerStatus = this.customerStatusAllList.find(s => s.customerStatusId == this.customerStatusID);
            //this.currentStatus = customerStatus!;
            //this.currentStep = customerStatus!.stage - 1;
            this.setCurrentStatus();
            this.setDisplayStatusList();
            this.setCurrentStep();
        }
        this.getCustomer();
    }

    public isChecklistMapDisabled(checklist: CustomerStatusChecklist) {
        if (this.isCRMAdmin != true && checklist.description == "Disqualified") {
            return true;
        }
        else if (this.isCRMAdmin != true && this.currentStatus.description == 'Customer') {
            return true;
        }
        else {
            return false;
        }
    }

    private setCurrentStatus() {
        var status = this.customerStatusAllList.find(s => s.customerStatusId == this.customerStatusID);
        if (status != null) {
            this.currentStatus = status;
        }
        else {
            this.currentStatus = this.customerStatusAllList[0];
        }
    }

    private setCurrentStep() {
        var idx = this.customerStatusList.findIndex(s => s.customerStatusId == this.customerStatusID);
        if (idx >= 0) {
            this.currentStep = idx;
        }
        else {
            this.currentStep = 0;
        }
    }

    private getEmployees() {
        //this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
        //    this.employees = result;
        //});
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.employees = result;
        });
    }

    private getCustomer() {
        this.crmService.getCustomerById(this.selectedCustomerID).subscribe(result => {
            this.customer = result;
        });
    }

    private getCustomerStatuses() {
        this.utilService.isLoading = true;
        this.crmService.getCustomerStatuses().subscribe(result => {
            this.utilService.isLoading = false;
            this.customerStatusAllList = result;
            this.customerStatusAllList = this.customerStatusAllList.filter(t => t.retiredInd != true);
            this.customerStatusAllList = this.customerStatusAllList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
            //var customerStatus = this.customerStatusAllList.find(s => s.customerStatusId == this.customerStatusID);
            //this.currentStatus = customerStatus!;
            //this.currentStep = customerStatus!.stage - 1;
            this.setCurrentStatus();
            this.setDisplayStatusList();
            this.setCurrentStep();

            this.getCustomerStatusChecklists();
        });
    }

    private getCustomerStatusChecklists() {
        this.utilService.isLoading = true;
        this.crmService.getCustomerStatusChecklists().subscribe(result => {
            this.utilService.isLoading = false;
            this.customerStatusChecklists = result;

            var sortDesc = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;
            if (sortDesc.sort) {
                this.customerStatusChecklists = orderBy(this.customerStatusChecklists, sortDesc.sort);
            }

            this.getChecklistMapsByCustomerId();
        });
    }

    private getChecklistMapsByCustomerId() {
        if (this.selectedCustomerID < 1) return;

        this.utilService.isLoading = true;
        this.crmService.getCustomerStatusChecklistMapsByCustomerId(this.selectedCustomerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.checklistMaps = result;
            this.setAllChecklistMaps();
        });
    }

    private setAllChecklistMaps() {
        this.allChecklistMaps = [];
        for (var i = 0; i < this.customerStatusChecklists.length; i++) {
            var checklistMap = Object.assign({}, this.checklistMaps.find(t => t.customerStatusChecklistId == this.customerStatusChecklists[i].customerStatusChecklistID));
            if (checklistMap.customerStatusChecklistMapID == undefined) {
                checklistMap = {
                    customerStatusChecklistMapID: 0,
                    customerStatusChecklistId: this.customerStatusChecklists[i].customerStatusChecklistID,
                    customerID: this.customerID,
                    completed: false,
                    notes: ""
                } as CustomerStatusChecklistMap;

            }
            this.allChecklistMaps.push(checklistMap);
        }
        //console.log("setAllChecklistMaps", this.allChecklistMaps, this.customerStatusChecklists);
    }

    public isChecklistMapCompleted(checklist: CustomerStatusChecklist) {
        var checklistMap: CustomerStatusChecklistMap = this.checklistMaps.find(t => t.customerStatusChecklistId == checklist.customerStatusChecklistID) as CustomerStatusChecklistMap;
        if (checklistMap != null && checklistMap.completed == true) {
            return true;
        }
        else {
            return false;
        }
    }

    private setDisplayStatusList() {
        if (this.currentStatus.statusType == "Lead" || this.isShowLeadStatusType) {
            this.customerStatusList = Object.assign([], this.customerStatusAllList);
        }
        else {
            this.customerStatusList = this.customerStatusAllList.filter(t => t.statusType != "Lead");
        }
    }

    public isShowStatus(status: CustomerStatus) {
        var isShow: boolean = false;
        if (status.statusType == "Lead" && (this.currentStatus.statusType == "Lead" || this.isShowLeadStatusType)) {
            isShow = true;
        }
        //console.log("isShowStatus", status, this.currentStatus, this.isShowLeadStatusType);
        return isShow;
    }

    public activate(evt: any) {
        //console.log("activate", this.currentStep, this.currentChecklistID, this.currentStatus, evt);
    }

    public currentStepChange(evt: any) {
        //var stage = parseInt(evt) + 1;
        //var customerStatus = this.customerStatusAllList.find(s => s.stage == stage);
        var idx = parseInt(evt);
        var customerStatus = this.customerStatusList[idx];
        this.currentStatus = customerStatus!;
    }

    public getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    public saveChecklistMap(checklist: CustomerStatusChecklist, changeType: string, evt: any) {
        //console.log("saveChecklistMap", checklist, this.allChecklistMaps);
        var listMap = this.checklistMaps.find(s => s.customerStatusChecklistId == checklist.customerStatusChecklistID);
        var currentChecklistMap = this.allChecklistMaps.find(s => s && s.customerStatusChecklistId == checklist.customerStatusChecklistID) as CustomerStatusChecklistMap;

        this.customerStatusChecklists;
        var completed = currentChecklistMap!.completed as boolean;
        var notes = currentChecklistMap!.notes.toString();

        if (!completed && notes.length < 1 && listMap != null) {
            this.utilService.isLoading = true;
            this.crmService.deleteCustomerChecklistMap(listMap).subscribe(result => {
                this.utilService.isLoading = false;
                this.getChecklistMapsByCustomerId();
                this.refreshData();
                this.onRefresh.emit();
                return;
            });
        }

        if (!completed || notes.length < 1) {
            return;
        }

        if (listMap == null) {
            listMap = {
                customerStatusChecklistMapID: 0,
                customerStatusChecklistId: checklist.customerStatusChecklistID,
                customerID: this.selectedCustomerID,
                createdByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                lastModifiedByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!)
            } as CustomerStatusChecklistMap;
        } else {
            listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
        }

        if (listMap.notes == notes && listMap.completed == completed) return;

        listMap.completed = completed;
        listMap.notes = notes;

        this.utilService.isLoading = true;
        this.crmService.saveCustomerStatusChecklistMap(listMap).subscribe(result => {
            this.utilService.isLoading = false;
            var checklist = this.checklistMaps.find(c => c.customerStatusChecklistMapID == result.customerStatusChecklistMapID);

            if (checklist == null) {
                this.checklistMaps.push(result);
            } else {
                checklist.createdByEmployeeID = result.createdByEmployeeID;
            }
            this.refreshData();
            this.onRefresh.emit();
        });
        //console.log("saveChecklistMap:currentChecklistMap", completed, notes, listMap, checklist, this.allChecklistMaps);
    }

    public getCompletedChecklistTimestamp(checklist: CustomerStatusChecklist) {
        var listMap = this.checklistMaps.find(c => c.customerStatusChecklistId == checklist.customerStatusChecklistID);

        if (listMap == null || listMap.customerStatusChecklistMapID < 1 || !listMap.completed) return '';

        var completedDate = new Date(listMap.completedDate);
        var employee = this.employees.find(e => e.employeeId == listMap!.createdByEmployeeID);

        return ' | Completed '
            + (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear()
            + ' by ' + (employee == null ? '' : employee.fullName);
    }
}
